import { useCallback, useMemo } from "react";
import { useLocalStorageState } from "./useLocalStorageState";
import { flattenAll } from "./searchUtils";

/**
 * Favoritos por usuario (persistidos en localStorage). Solo se guarda el id
 * del ítem: la lista de favoritos "resueltos" se recalcula contra el árbol
 * actual, así que si el backend deja de entregar un ítem (permiso
 * revocado), el favorito desaparece solo, sin dejar rutas fantasma.
 */
export function useMenuFavorites(idUsuario, tree) {
  const storageKey = `sidebar_favorites_${idUsuario || "anon"}`;
  const [favoriteIds, setFavoriteIds] = useLocalStorageState(storageKey, []);

  const toggleFavorite = useCallback(
    (itemId) => {
      setFavoriteIds((prev) =>
        prev.includes(itemId) ? prev.filter((id) => id !== itemId) : [...prev, itemId]
      );
    },
    [setFavoriteIds]
  );

  const isFavorite = useCallback((itemId) => favoriteIds.includes(itemId), [favoriteIds]);

  const favoriteItems = useMemo(() => {
    if (!favoriteIds.length) return [];
    const byId = new Map(flattenAll(tree).map(({ item }) => [item.id, item]));
    return favoriteIds.map((id) => byId.get(id)).filter((item) => item && item.route);
  }, [favoriteIds, tree]);

  return { favoriteItems, isFavorite, toggleFavorite };
}
